import React, { useState } from "react";

interface Faq {
  id: string;
  question: string;
  answer: string;
}

const faqs: Faq[] = [
  {
    id: "accordion-1",
    question: "Quels types de support technique offre J-Tronics ?",
    answer:
      "J-Tronics propose une assistance téléphonique et en ligne pour résoudre les problèmes techniques rencontrés avec nos équipements. Nous offrons également des guides d'utilisation détaillés et des solutions de dépannage pour tous nos produits.",
  },
  {
    id: "accordion-2",
    question: "Comment fonctionne la maintenance préventive chez J-Tronics ?",
    answer:
      "Nous avons mis en place des programmes de maintenance régulière pour assurer le bon fonctionnement continu de vos équipements. Cela comprend des inspections périodiques et des interventions de maintenance sur site pour prévenir les pannes potentielles.",
  },
  {
    id: "accordion-3",
    question:
      "Quelles sont les options pour les réparations et les pièces de rechange ?",
    answer:
      "En cas de besoin, notre équipe propose un service de réparation rapide et efficace pour minimiser les temps d'arrêt. Nous disposons également d'un stock de pièces de rechange pour assurer des réparations immédiates et efficaces.",
  },
  {
    id: "accordion-4",
    question: "Est-ce que J-Tronics offre des formations aux utilisateurs ?",
    answer:
      "Oui, nous organisons des sessions de formation pour vous et votre équipe afin de vous familiariser avec l'utilisation et l'entretien de nos équipements. Nous fournissons également une documentation complète et des tutoriels vidéo pour faciliter la prise en main.",
  },
  {
    id: "accordion-5",
    question: "Comment J-Tronics gère les mises à jour et les améliorations ?",
    answer:
      "Nous vous tenons informés des dernières mises à jour logicielles et nous proposons des améliorations pour optimiser les performances de vos équipements. Notre objectif est de garantir que vous bénéficiez toujours des dernières technologies et fonctionnalités améliorées.",
  },
  {
    id: "accordion-6",
    question: "Quelle est la politique de garantie et de support contractuel ?",
    answer:
      "Nous offrons une garantie standard sur tous nos produits, avec des options pour des extensions de garantie et un support contractuel personnalisé pour répondre à vos besoins spécifiques en matière de maintenance et de service après-vente.",
  },
  {
    id: "accordion-7",
    question: "Comment J-Tronics mesure la satisfaction client ?",
    answer:
      "Nous recueillons régulièrement vos commentaires et vos suggestions pour améliorer nos produits et services. Notre équipe est dédiée à assurer votre satisfaction et à répondre à toutes vos attentes en termes de qualité et de support.",
  },
];

const AskedQuestions: React.FC = () => {
  const [openAccordions, setOpenAccordions] = useState<string[]>([]);

  const toggleAccordion = (id: string) => {
    setOpenAccordions(
      (prev) =>
        prev.includes(id)
          ? prev.filter((item) => item !== id) // Close if already open
          : [...prev, id] // Open if closed
    );
  };

  return (
    <div className="relative mx-auto w-full py-16 px-5 font-sans text-gray-800 sm:px-20 md:max-w-screen-lg lg:py-24">
      <h1 className="mb-4 text-2xl font-bold text-center animate-bounce text-blue-600 sm:text-5xl xl:text-6xl mt-14">
        Service Après-Vente
      </h1>
      <h2 className="mb-5 text-center font-sans text-xl sm:text-5xl font-bold">
        Questions Fréquemment Posées
      </h2>
      <p className="mb-12 text-center text-lg text-gray-600">
        Nous avons répondu à certaines des questions fréquemment posées. Si vous
        avez d'autres questions, n'hésitez pas à nous contacter via Contact.
      </p>
      <ul className="space-y-4">
        {faqs.map((faq) => (
          <li key={faq.id} className="text-left">
            <label
              htmlFor={faq.id}
              className="relative flex flex-col rounded-md border border-gray-100 shadow-md"
            >
              <input
                type="checkbox"
                className="peer hidden"
                id={faq.id}
                checked={openAccordions.includes(faq.id)}
                onChange={() => toggleAccordion(faq.id)}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="absolute right-0 top-4 ml-auto mr-5 h-4 text-gray-500 transition peer-checked:rotate-180"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
              <div className="relative ml-4 cursor-pointer select-none items-center py-4 pr-12">
                <h3 className="text-base text-gray-700 lg:text-lg">
                  {faq.question}
                </h3>
              </div>
              <div className="max-h-0 overflow-hidden transition-all duration-500 peer-checked:max-h-96">
                <div className="p-5">
                  <p className="text-sm">{faq.answer}</p>
                </div>
              </div>
            </label>
          </li>
        ))}
      </ul>
      <div className="mt-20 flex justify-center">
        <a
          href="/contact"
          className="inline-block cursor-pointer rounded-lg font-bold text-xl text-white bg-blue-600 rounded-md hover:bg-blue-700 transition duration-300 ease-in-out py-3 px-5 text-lg"
        >
          Vous avez encore des questions ?
        </a>
      </div>
    </div>
  );
};

export default AskedQuestions;
